import React from 'react';
import { map, prop } from 'ramda';
import SelectTags from '../../SelectTags';

const TAG_SECTIONS = [
  {
    label: 'Risques', itemType: 'risk', key: 'risks'
  },
  {
    label: 'Gammes', itemType: 'range', key: 'ranges'
  },
  {
    label: 'Types de documents', itemType: 'documentType', key: 'documentTypes'
  }
];

const AnalyticsTagsForm = ({ values, onChange, offerId, documentId, setRefetchTags, isControlled }) => {
  return (
    <div className="flex flex-col gap-2">
      {
        map((tag) => {
          const key = prop('key', tag);
          return (
            <SelectTags
              key={key}
              label={prop('label', tag)}
              itemType={prop('itemType', tag)}
              value={prop(key, values)}
              onChange={isControlled ? (value) => onChange(key, value) : null}
              offerId={offerId}
              documentId={documentId}
              setRefetchTags={setRefetchTags}
              isControlled={isControlled}
              isGlobal
            />
          );
        })(TAG_SECTIONS)
      }
    </div>
  );
};

export default AnalyticsTagsForm;
